<template>
  <div :class="rootClasses" :style="rootStyles">
    <ElementControls
      v-if="editing"
      :no-page-break="!pageBreakAllowed"
      @delete="$emit('delete')"
      @duplicate="$emit('duplicate')"
      @page-break="$emit('page-break')"
      @hide="$emit('hide')"
    />
    <AnalyticsWrapper>
      <div :class="layoutClasses">
        <div
          v-if="label || description"
          class="formester-label-description-wrapper"
          :style="labelDescriptionWrapperStyles"
        >
          <label
            :class="labelClasses"
            :style="labelStyles"
            :for="item.label + item.id"
            v-html="label"
          />
          <SmartText
            :active="active"
            :editing="editing"
            :item="item"
            :style="descriptionStyles"
            :text="description"
          />
        </div>

        <input
          :id="item.label + item.id"
          ref="input"
          v-model="itemValue"
          :data-uuid="item.id"
          type="time"
          :readonly="editing"
          :class="inputClasses"
          :style="[inputStyles, fieldStyles]"
          :min="item.start"
          :max="item.end"
          :placeholder="item.placeholder"
          :name="item.label"
          :required="item.required"
          :disabled="isFieldDisabled"
          @focus="focus"
          @blur="blur"
          @onmouseenter="isiOSDevice ? focus : null"
          @onmouseout="isiOSDevice ? blur : null"
        />
        <LockIndicator :item="item" />
        <ErrorMessage :item="item" />
      </div>
    </AnalyticsWrapper>
  </div>
</template>

<script>
import ElementControls from "@/components/form_fields/shared/element-controls.vue";
import commonStyles from "@/components/form_fields/shared/commonStyles";
import sharedActions from "@/components/form_fields/shared/sharedActions";
import SmartText from "@/components/form_fields/shared/smart-text.vue";
import ErrorMessage from "@/components/form_fields/shared/error-message.vue";
import { set as setItem } from "lodash-es";
import AnalyticsWrapper from "@/components/form_fields/shared/analytics-wrapper.vue";
import { isIosDevice } from "@/helpers/utils";

export default {
  name: "TimeInput",
  components: {
    ElementControls,
    ErrorMessage,
    SmartText,
    AnalyticsWrapper,
  },
  mixins: [commonStyles, sharedActions],
  props: {
    item: {
      type: Object,
      required: true,
    },
    required: {
      type: Boolean,
      default: false,
    },
    editing: {
      type: Boolean,
      default: false,
    },
    active: {
      type: Boolean,
      default: false,
    },
    styling: {
      type: Object,
      required: true,
    },
    pageBreakAllowed: {
      type: Boolean,
      default: true,
    },
  },
  emits: ["delete", "page-break", "duplicate", "hide"],
  data() {
    return {
      isiOSDevice: false,
    };
  },
  computed: {
    itemValue: {
      get() {
        return this.item.value;
      },
      set(e) {
        setItem(this.item, "value", e);
      },
    },
    itemDefault() {
      return this.item.value;
    },
    inputClasses() {
      return {
        "formester-input": true,
        "formester-input__shorttext": true,
        "form-control": this.isiOSDevice,
      };
    },
  },
  mounted() {
    this.isiOSDevice = isIosDevice();

    if (this.itemDefault) {
      if (
        !this.isiOSDevice &&
        this.$refs.input &&
        this.$refs.input.type !== "time"
      ) {
        this.$refs.input.type = "time";
      }
    } else {
      if (
        !this.isiOSDevice &&
        this.$refs.input &&
        this.$refs.input.type !== "text"
      ) {
        this.$refs.input.type = "text";
      }
    }
  },
  methods: {
    focus() {
      if (this.$refs.input) {
        this.$refs.input.type = "time";
      }
      this.handleFocus();
    },
    blur() {
      const inputField = this.$refs.input;
      if (!inputField) return;

      if (!inputField.value) {
        this.$refs.input.type = "text";
      }

      this.handleBlur();
    },
  },
};
</script>

<style></style>
